import request from '../utils/request'

export function getOpsResourceItems(params) {
  return request({
    url: '/api/admin/ops/resource-items',
    method: 'get',
    params
  })
}

export function getOpsResourceItemDetail(id) {
  return request({
    url: `/api/admin/ops/resource-items/${id}`,
    method: 'get'
  })
}

export function createOpsResourceItem(data) {
  return request({
    url: '/api/admin/ops/resource-items',
    method: 'post',
    data
  })
}

export function updateOpsResourceItem(id, data) {
  return request({
    url: `/api/admin/ops/resource-items/${id}`,
    method: 'put',
    data
  })
}

export function enableOpsResourceItem(id) {
  return request({
    url: `/api/admin/ops/resource-items/${id}/enable`,
    method: 'post'
  })
}

export function disableOpsResourceItem(id) {
  return request({
    url: `/api/admin/ops/resource-items/${id}/disable`,
    method: 'post'
  })
}

export function sortOpsResourceItem(id, data) {
  return request({
    url: `/api/admin/ops/resource-items/${id}/sort`,
    method: 'post',
    data
  })
}
